unit diesel.fuelorders.enquiry;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  WEBLib.Buttons, WEBLib.DBCtrls, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCGridCell,
  VCL.TMSFNCGridOptions, VCL.TMSFNCCustomComponent, VCL.TMSFNCCustomGrid,
  VCL.TMSFNCGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCCustomScrollControl, VCL.TMSFNCGridData, VCL.TMSFNCGrid,
  XData.Web.Client, Vcl.Imaging.GIFImg, WEBLib.TMSWEBCustomComponent,
  WEBLib.TMSWEBStateManager, WEBLib.TMSWEBResponsiveManager, WEBLib.ComCtrls;

type
  TfrmFuelOrders = class(TForm)
    webconnect: TXDataWebClient;
    qInfo: TXDataWebDataSet;
    dsInfo: TDataSource;
    MessageDlg: TMessageDlg;
    WebTimer1: TTimer;
    qInfoOrderNo: TIntegerField;
    qInfoOrderDate: TDateField;
    qInfoRegNo: TStringField;
    qInfoDepotCode: TIntegerField;
    qInfoDepotName: TStringField;
    qInfoSubCode: TStringField;
    qInfoSubName: TStringField;
    qInfoFleetNo: TStringField;
    qInfoOrderLiters: TFloatField;
    qInfoInvoicedLiters: TFloatField;
    qInfoCanceled: TBooleanField;
    qInfoCInvoiced: TBooleanField;
    qInfoSInvoiced: TBooleanField;
    qInfoSupplierCode: TStringField;
    qInfoSupplierName: TStringField;
    qInfoSOrderNo: TStringField;
    qInfoSInvoiceNo: TStringField;
    qInfoOrderPrice: TFloatField;
    qInfoOrderAmount: TFloatField;
    qInfoFillType: TBooleanField;
    qStatus: TXDataWebDataSet;
    qStatusOrderNo: TIntegerField;
    qStatusValid: TBooleanField;
    qStatusSystemMessage: TStringField;
    qInfoInProgress: TBooleanField;
    WebPanel2: TPanel;
    WebScrollBox1: TScrollBox;
    WebPanel1: TPanel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    eSubsCompany: TEdit;
    btnSearchSubs: TSpeedButton;
    wdpStart: TDateTimePicker;
    wdpEnd: TDateTimePicker;
    btnSearch: TSpeedButton;
    WebLabel5: TLabel;
    eRegNo: TEdit;
    btnRegNo: TSpeedButton;
    gInfo: TTMSFNCGrid;
    wpBottom: TPanel;
    btnNew: TSpeedButton;
    btnEdit: TSpeedButton;
    btnCancel: TSpeedButton;
    btnClose: TSpeedButton;
    ePages: TEdit;
    btnFirst: TSpeedButton;
    btnNext: TSpeedButton;
    btnPrior: TSpeedButton;
    btnLast: TSpeedButton;
    procedure btnSearchClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure WebTimer1Timer(Sender: TObject);
    procedure btnNewClick(Sender: TObject);
    procedure btnEditClick(Sender: TObject);
    procedure gInfoGetCellLayout(Sender: TObject; ACol, ARow: Integer;
      ALayout: TTMSFNCGridCellLayout; ACellState: TTMSFNCGridCellState);
    procedure btnCloseClick(Sender: TObject);
    procedure eSubsCompanyKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure btnSearchSubsClick(Sender: TObject);
    procedure qInfoAfterOpen(DataSet: TDataSet);
    procedure eRegNoKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure btnRegNoClick(Sender: TObject);
    procedure btnFirstClick(Sender: TObject);
    procedure btnPriorClick(Sender: TObject);
    procedure btnNextClick(Sender: TObject);
    procedure btnLastClick(Sender: TObject);
    procedure btnCancelClick(Sender: TObject);
  private
    { Private declarations }
    procedure LoadData;
    procedure StartLoadData;
    procedure UpdatePageButtons;
  public
    { Public declarations }
    username : String;
    iSystemType,
    iPageNo,
    iPageCount : Integer;
    sCompany,
    sRegNo : String;
    bAllowSearchChange : Boolean;
  protected procedure LoadDFMValues; override; end;

var
  frmFuelOrders: TfrmFuelOrders;

implementation

{$R *.dfm}

Uses
  stfmssystem.connection,
  share.classes,
  diesel.fuelorders.create,
  search.subsdiesel,
  search.reg;

procedure TfrmFuelOrders.btnCancelClick(Sender: TObject);
  procedure OnResultCreate(Response : TXDataClientResponse);
  begin
    try
      qStatus.Close;
      qStatus.SetJsonData(Response.Result);
      qStatus.Open;

      If not qStatus.FieldByName('Valid').asBoolean then
        MessageDlg.ShowDialog(qStatus.FieldByName('SystemMessage').asString, WEBLib.Dialogs.mtError, [mbOk])
      else
        StartLoadData;
    except
      On E:Exception do
        MessageDlg.ShowDialog(E.Message, WEBLib.Dialogs.mtError, [mbOk]);
    end;
  end;

begin
  webConnect.RawInvoke('IstfmssubsService.CancelDieselOrderDepot',
                       [qInfo.FieldByName('OrderNo').asInteger,iSystemType],@OnResultCreate);
end;

procedure TfrmFuelOrders.btnCloseClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmFuelOrders.btnEditClick(Sender: TObject);
  var
    LFrm : TfrmCreateDieselOrders;
  procedure AfterCreate(AForm : TObject);
  begin
    (AForm as TfrmCreateDieselOrders).UserName := UserName;
    (AForm as TfrmCreateDieselOrders).bInsert := False;
    (AForm as TfrmCreateDieselOrders).iOrderNo := qInfo.FieldByName('OrderNo').AsInteger;
    (AForm as TfrmCreateDieselOrders).sSubs := sCompany;
    (AForm as TfrmCreateDieselOrders).iSystemType := iSystemType;
  end;
begin
  LFrm := TfrmCreateDieselOrders.CreateNew( @AfterCreate );

  // LFrm als Pop-Up festlegen
  LFrm.Popup := true;

  // Transparenz definieren
  LFrm.PopupOpacity := 0.2;

  LFrm.ShowModal;
end;

procedure TfrmFuelOrders.btnFirstClick(Sender: TObject);
begin
  iPageNo := 1;
  UpdatePageButtons;
  LoadData;
end;

procedure TfrmFuelOrders.btnLastClick(Sender: TObject);
begin
  iPageNo := iPageCount;
  UpdatePageButtons;
  LoadData
end;

procedure TfrmFuelOrders.btnNewClick(Sender: TObject);
  var
    LFrm : TfrmCreateDieselOrders;
  procedure AfterShowModal(AValue: TModalResult);
  begin
    StartLoadData;
  end;
  procedure AfterCreate(AForm : TObject);
  begin
    (AForm as TfrmCreateDieselOrders).UserName := UserName;
    (AForm as TfrmCreateDieselOrders).bInsert := True;
    (AForm as TfrmCreateDieselOrders).iOrderNo := -1;
    Case iSystemType of
      0 : begin
            if bAllowSearchChange then
              begin
                (AForm as TfrmCreateDieselOrders).sSubs := '*';
                (AForm as TfrmCreateDieselOrders).lCompany.Text := '';
                (AForm as TfrmCreateDieselOrders).sRegNo := '*';
                (AForm as TfrmCreateDieselOrders).lRegNo.Text := '';
                (AForm as TfrmCreateDieselOrders).bForceReg := False;
                (AForm as TfrmCreateDieselOrders).bForceComp := False;
              end
            else
              begin
                if sCompany = '' then
                  begin
                    (AForm as TfrmCreateDieselOrders).sSubs := '*';
                    (AForm as TfrmCreateDieselOrders).lCompany.Text := '';
                    (AForm as TfrmCreateDieselOrders).bForceComp := False;
                  end
                else
                  begin
                    (AForm as TfrmCreateDieselOrders).sSubs := sCompany;
                    (AForm as TfrmCreateDieselOrders).lCompany.Text := eSubsCompany.Text;
                    (AForm as TfrmCreateDieselOrders).bForceComp := True;
                  end;
                if sRegNo = '' then
                  begin
                    (AForm as TfrmCreateDieselOrders).sRegNo := '*';
                    (AForm as TfrmCreateDieselOrders).lRegNo.Text := '';
                    (AForm as TfrmCreateDieselOrders).bForceReg := False;
                  end
                else
                  begin
                    (AForm as TfrmCreateDieselOrders).sRegNo := sRegNo;
                    (AForm as TfrmCreateDieselOrders).lRegNo.Text := eRegNo.Text;
                    (AForm as TfrmCreateDieselOrders).bForceReg := True;
                  end;
              end;
          end;
      1 : begin
            (AForm as TfrmCreateDieselOrders).sSubs := sCompany;
            (AForm as TfrmCreateDieselOrders).lCompany.Text := eSubsCompany.Text;
            if Trim(sCompany) = '' then
              (AForm as TfrmCreateDieselOrders).bForceComp := False
            else
              (AForm as TfrmCreateDieselOrders).bForceComp := True;
            (AForm as TfrmCreateDieselOrders).sRegNo := '*';
            (AForm as TfrmCreateDieselOrders).bForceReg := False;
          end;
    End;
    (AForm as TfrmCreateDieselOrders).iSystemType := iSystemType;
  end;
begin
  LFrm := TfrmCreateDieselOrders.CreateNew( @AfterCreate );
  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmFuelOrders.btnNextClick(Sender: TObject);
begin
  iPageNo := iPageNo + 1;
  UpdatePageButtons;
  LoadData;
end;

procedure TfrmFuelOrders.btnPriorClick(Sender: TObject);
begin
  iPageNo := iPageNo - 1;
  UpdatePageButtons;
  LoadData;
end;

procedure TfrmFuelOrders.btnRegNoClick(Sender: TObject);
  var
    LFrm : TfrmSearchReg;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    with LFrm do
      begin
        if sCode <> '' then
          begin
            eRegNo.Text := sName;
            sRegNo := sCode;
          end
        else
          begin
            eRegNo.Text := '';
            sRegNo := '';
          end;
      end;
  end;

  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmSearchReg) do
      begin
        bSuspended := True;
        iType := iSystemType;
        if UserName = '*' then
          sController := '*'
        else
          sController := UserName;
        if sCompany = '' then
          sSearchSub := '*'
        else
          sSearchSub := sCompany;
        GetData;
      end;
  end;
begin
  LFrm := TfrmSearchReg.CreateNew( @AfterCreate );

  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmFuelOrders.btnSearchClick(Sender: TObject);
begin
  StartLoadData;
end;

procedure TfrmFuelOrders.btnSearchSubsClick(Sender: TObject);
  var
    LFrm : TfrmSearchSubsDiesel;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    with LFrm do
      begin
        if sCode <> '' then
          begin
            eSubsCompany.Text := sName;
            sCompany := sCode;
          end
        else
          begin
            eSubsCompany.Text := '';
            sCompany := '';
          end;
      end;
  end;

  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmSearchSubsDiesel) do
      begin
        bSuspended := True;
        iType := iSystemType;
        sUserName := UserName;
        GetData;

      end;
  end;
begin
  LFrm := TfrmSearchSubsDiesel.CreateNew( @AfterCreate );

  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmFuelOrders.eRegNoKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if Key = VK_Delete then
    begin
      eRegNo.Text := '';
      sRegNo := '';
    end;
end;

procedure TfrmFuelOrders.eSubsCompanyKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if Key = VK_Delete then
    begin
      eSubsCompany.Text := '';
      sCompany := '';
    end;
end;

procedure TfrmFuelOrders.gInfoGetCellLayout(Sender: TObject; ACol,
  ARow: Integer; ALayout: TTMSFNCGridCellLayout;
  ACellState: TTMSFNCGridCellState);
begin
  if (ARow >= gInfo.FixedRows) then
    begin
      if dsInfo.DataSet.FieldByName('InProgress').asBoolean then
        ALayout.Fill.Color := gcYellow;
    end;
end;

procedure TfrmFuelOrders.LoadData;
  var
    sSubCode,
    sController,
    sRegNoSearch : String;
    iDepotCode : Integer;
  procedure OnResultSummary(Response : TXDataClientResponse);
  begin
    try
      qInfo.Close;
      qInfo.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      qInfo.Open;
    except
      On E:Exception do
        MessageDlg.ShowDialog(E.Message, WEBLib.Dialogs.mtError, [mbOk]);
    end;
  end;
begin
  //WebWaitMessage1.Show;
  if Trim(sCompany) = '' then
    sSubCode := '*'
  else
    sSubCode := sCompany;
  if Username = '' then
    sController := '*'
  else
    sController := Username;
  if sRegNo = '' then
    sRegNoSearch := '*'
  else
    sRegNoSearch := sRegNo;
  iDepotCode := -1;
  webConnect.RawInvoke('IstfmsdieselService.GetDieselOrders',
                       [sController, sSubCode, sRegNoSearch,
                       wdpStart.Date,wdpEnd.Date, iDepotCode, iPageNo, False, False,iSystemType],@OnResultSummary);
end;

procedure TfrmFuelOrders.qInfoAfterOpen(DataSet: TDataSet);
begin
  TFloatField(qInfo.FieldByName('orderliters')).DisplayFormat := '#,##0.00';
  TFloatField(qInfo.FieldByName('orderprice')).DisplayFormat := '#,##0.00';
  TFloatField(qInfo.FieldByName('orderamount')).DisplayFormat := '#,##0.00';
  TDateField(qInfo.FieldByName('orderdate')).DisplayFormat := 'dd/MM/yyyy';
  {if WebWaitMessage1.Visible then
    WebWaitMessage1.Hide;}
  if qInfo.IsEmpty then
    begin
      btnEdit.Visible := False;
      btnCancel.Visible := False;
    end
  else
    begin
      btnEdit.Visible := False;
      btnCancel.Visible := True;
    end;
end;

procedure TfrmFuelOrders.StartLoadData;
  var
    sSubCode,
    sController,
    sRegNoSearch : String;
    iDepotCode : Integer;
  procedure OnResultSummary(Response : TXDataClientResponse);
  begin
    try
      iPageCount := JS.ToInteger(JS.ToObject(Response.Result)['value']);
      iPageNo := 1;

      UpdatePageButtons;

      LoadData;
    except
      On E:Exception do
        MessageDlg.ShowDialog(E.Message, WEBLib.Dialogs.mtError, [mbOk]);
    end;
  end;
begin
  //WebWaitMessage1.Show;
  if Trim(sCompany) = '' then
    sSubCode := '*'
  else
    sSubCode := sCompany;
  if Username = '' then
    sController := '*'
  else
    sController := Username;
  if sRegNo = '' then
    sRegNoSearch := '*'
  else
    sRegNoSearch := sRegNo;
  iDepotCode := -1;
  webConnect.RawInvoke('IstfmsdieselService.GetDieselOrdersPageCount',
                       [sController, sSubCode, sRegNoSearch,
                       wdpStart.Date,wdpEnd.Date, iDepotCode, False, False,iSystemType],@OnResultSummary);
end;

procedure TfrmFuelOrders.UpdatePageButtons;
begin
  ePages.Text := IntToStr(iPageNo) + ' of ' + IntToStr(iPageCount);
  if iPageNo > 1 then
    begin
      btnFirst.Enabled := True;
      btnPrior.Enabled := True;
    end
  else
    begin
      btnFirst.Enabled := False;
      btnPrior.Enabled := False;
    end;
  if (iPageCount > 1) and (iPageNo < iPageCount) then
    begin
      btnNext.Enabled := True;
      btnLast.Enabled := True;
    end
  else
    begin
      btnNext.Enabled := False;
      btnLast.Enabled := False;
    end;
end;

procedure TfrmFuelOrders.WebFormShow(Sender: TObject);
  var
    wYear,
    wMonth,
    wDay : Word;
begin
  DecodeDate(Date,wYear,wMonth,wDay);
  wdpStart.Date := EncodeDate(wYear,wMonth,1);
  wdpEnd.Date := Date;

  //btnSearchSubs.Enabled := bAllowSearchChange;
  //eSubsCompany.Enabled := bAllowSearchChange;
  //btnRegNo.Enabled := bAllowSearchChange;
  //eRegNo.Enabled := bAllowSearchChange;

  //if not bAllowSearchChange then
    StartLoadData;
  //webConnect.RawInvoke('IstfmssubsService.GetSubCompanies',
  //                     [username,iSystemType,True],@OnResultSummary);
end;

procedure TfrmFuelOrders.WebTimer1Timer(Sender: TObject);
begin
  StartLoadData;
end;

procedure TfrmFuelOrders.LoadDFMValues;
begin
  inherited LoadDFMValues;

  MessageDlg := TMessageDlg.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebScrollBox1 := TScrollBox.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  eSubsCompany := TEdit.Create(Self);
  btnSearchSubs := TSpeedButton.Create(Self);
  wdpStart := TDateTimePicker.Create(Self);
  wdpEnd := TDateTimePicker.Create(Self);
  btnSearch := TSpeedButton.Create(Self);
  eRegNo := TEdit.Create(Self);
  btnRegNo := TSpeedButton.Create(Self);
  gInfo := TTMSFNCGrid.Create(Self);
  wpBottom := TPanel.Create(Self);
  btnNew := TSpeedButton.Create(Self);
  btnEdit := TSpeedButton.Create(Self);
  btnCancel := TSpeedButton.Create(Self);
  btnClose := TSpeedButton.Create(Self);
  ePages := TEdit.Create(Self);
  btnFirst := TSpeedButton.Create(Self);
  btnNext := TSpeedButton.Create(Self);
  btnPrior := TSpeedButton.Create(Self);
  btnLast := TSpeedButton.Create(Self);
  webconnect := TXDataWebClient.Create(Self);
  qInfo := TXDataWebDataSet.Create(Self);
  qInfoOrderNo := TIntegerField.Create(Self);
  qInfoOrderDate := TDateField.Create(Self);
  qInfoRegNo := TStringField.Create(Self);
  qInfoDepotCode := TIntegerField.Create(Self);
  qInfoDepotName := TStringField.Create(Self);
  qInfoSubCode := TStringField.Create(Self);
  qInfoSubName := TStringField.Create(Self);
  qInfoFleetNo := TStringField.Create(Self);
  qInfoOrderLiters := TFloatField.Create(Self);
  qInfoInvoicedLiters := TFloatField.Create(Self);
  qInfoCanceled := TBooleanField.Create(Self);
  qInfoCInvoiced := TBooleanField.Create(Self);
  qInfoSInvoiced := TBooleanField.Create(Self);
  qInfoSupplierCode := TStringField.Create(Self);
  qInfoSupplierName := TStringField.Create(Self);
  qInfoSOrderNo := TStringField.Create(Self);
  qInfoSInvoiceNo := TStringField.Create(Self);
  qInfoOrderPrice := TFloatField.Create(Self);
  qInfoOrderAmount := TFloatField.Create(Self);
  qInfoFillType := TBooleanField.Create(Self);
  qInfoInProgress := TBooleanField.Create(Self);
  dsInfo := TDataSource.Create(Self);
  WebTimer1 := TTimer.Create(Self);
  qStatus := TXDataWebDataSet.Create(Self);
  qStatusOrderNo := TIntegerField.Create(Self);
  qStatusValid := TBooleanField.Create(Self);
  qStatusSystemMessage := TStringField.Create(Self);

  MessageDlg.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebScrollBox1.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  eSubsCompany.BeforeLoadDFMValues;
  btnSearchSubs.BeforeLoadDFMValues;
  wdpStart.BeforeLoadDFMValues;
  wdpEnd.BeforeLoadDFMValues;
  btnSearch.BeforeLoadDFMValues;
  eRegNo.BeforeLoadDFMValues;
  btnRegNo.BeforeLoadDFMValues;
  gInfo.BeforeLoadDFMValues;
  wpBottom.BeforeLoadDFMValues;
  btnNew.BeforeLoadDFMValues;
  btnEdit.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  ePages.BeforeLoadDFMValues;
  btnFirst.BeforeLoadDFMValues;
  btnNext.BeforeLoadDFMValues;
  btnPrior.BeforeLoadDFMValues;
  btnLast.BeforeLoadDFMValues;
  webconnect.BeforeLoadDFMValues;
  qInfo.BeforeLoadDFMValues;
  qInfoOrderNo.BeforeLoadDFMValues;
  qInfoOrderDate.BeforeLoadDFMValues;
  qInfoRegNo.BeforeLoadDFMValues;
  qInfoDepotCode.BeforeLoadDFMValues;
  qInfoDepotName.BeforeLoadDFMValues;
  qInfoSubCode.BeforeLoadDFMValues;
  qInfoSubName.BeforeLoadDFMValues;
  qInfoFleetNo.BeforeLoadDFMValues;
  qInfoOrderLiters.BeforeLoadDFMValues;
  qInfoInvoicedLiters.BeforeLoadDFMValues;
  qInfoCanceled.BeforeLoadDFMValues;
  qInfoCInvoiced.BeforeLoadDFMValues;
  qInfoSInvoiced.BeforeLoadDFMValues;
  qInfoSupplierCode.BeforeLoadDFMValues;
  qInfoSupplierName.BeforeLoadDFMValues;
  qInfoSOrderNo.BeforeLoadDFMValues;
  qInfoSInvoiceNo.BeforeLoadDFMValues;
  qInfoOrderPrice.BeforeLoadDFMValues;
  qInfoOrderAmount.BeforeLoadDFMValues;
  qInfoFillType.BeforeLoadDFMValues;
  qInfoInProgress.BeforeLoadDFMValues;
  dsInfo.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  qStatus.BeforeLoadDFMValues;
  qStatusOrderNo.BeforeLoadDFMValues;
  qStatusValid.BeforeLoadDFMValues;
  qStatusSystemMessage.BeforeLoadDFMValues;
  try
    Name := 'frmFuelOrders';
    Width := 949;
    Height := 570;
    Align := alClient;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    MessageDlg.SetParentComponent(Self);
    MessageDlg.Name := 'MessageDlg';
    MessageDlg.Left := 408;
    MessageDlg.Top := 288;
    MessageDlg.Width := 24;
    MessageDlg.Height := 24;
    MessageDlg.Buttons := [mbOK];
    MessageDlg.Opacity := 0.200000000000000000;
    MessageDlg.ElementButtonClassName := 'btn';
    MessageDlg.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    MessageDlg.ElementTitleClassName := 'text-body';
    MessageDlg.ElementContentClassName := 'text-body';
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 949;
    WebPanel2.Height := 41;
    WebPanel2.WidthStyle := ssPercent;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Diesel Order Enquiry';
    WebPanel2.ChildOrder := 4;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -15;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebScrollBox1.SetParentComponent(Self);
    WebScrollBox1.Name := 'WebScrollBox1';
    WebScrollBox1.Left := 0;
    WebScrollBox1.Top := 41;
    WebScrollBox1.Width := 949;
    WebScrollBox1.Height := 528;
    WebScrollBox1.BorderStyle := bsSingle;
    WebScrollBox1.ChildOrder := 11;
    WebPanel1.SetParentComponent(WebScrollBox1);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 949;
    WebPanel1.Height := 121;
    WebPanel1.ChildOrder := 11;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 8;
    WebLabel2.Top := 7;
    WebLabel2.Width := 118;
    WebLabel2.Height := 20;
    WebLabel2.Caption := 'Select Company : ';
    WebLabel2.ElementFont := efCSS;
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 320;
    WebLabel3.Top := 8;
    WebLabel3.Width := 107;
    WebLabel3.Height := 14;
    WebLabel3.Caption := 'Select Start Date : ';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -12;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [];
    WebLabel3.HeightStyle := ssAuto;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel1);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 478;
    WebLabel4.Top := 8;
    WebLabel4.Width := 101;
    WebLabel4.Height := 14;
    WebLabel4.Caption := 'Select End Date : ';
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -12;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [];
    WebLabel4.HeightStyle := ssAuto;
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel1);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 8;
    WebLabel5.Top := 59;
    WebLabel5.Width := 61;
    WebLabel5.Height := 20;
    WebLabel5.Caption := 'Reg No : ';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    eSubsCompany.SetParentComponent(WebPanel1);
    eSubsCompany.Name := 'eSubsCompany';
    eSubsCompany.Left := 8;
    eSubsCompany.Top := 28;
    eSubsCompany.Width := 254;
    eSubsCompany.Height := 22;
    eSubsCompany.ChildOrder := 8;
    eSubsCompany.HeightPercent := 100.000000000000000000;
    eSubsCompany.ReadOnly := True;
    eSubsCompany.WidthPercent := 100.000000000000000000;
    SetEvent(eSubsCompany, Self, 'OnKeyDown', 'eSubsCompanyKeyDown');
    btnSearchSubs.SetParentComponent(WebPanel1);
    btnSearchSubs.Name := 'btnSearchSubs';
    btnSearchSubs.Left := 262;
    btnSearchSubs.Top := 28;
    btnSearchSubs.Width := 24;
    btnSearchSubs.Height := 22;
    btnSearchSubs.Caption := '...';
    btnSearchSubs.Color := clNone;
    btnSearchSubs.Font.Charset := DEFAULT_CHARSET;
    btnSearchSubs.Font.Color := clWindowText;
    btnSearchSubs.Font.Height := -12;
    btnSearchSubs.Font.Name := 'Segoe UI';
    btnSearchSubs.Font.Style := [fsBold];
    btnSearchSubs.HeightPercent := 100.000000000000000000;
    btnSearchSubs.ParentFont := False;
    btnSearchSubs.TabOrder := 1;
    btnSearchSubs.WidthPercent := 100.000000000000000000;
    SetEvent(btnSearchSubs, Self, 'OnClick', 'btnSearchSubsClick');
    wdpStart.SetParentComponent(WebPanel1);
    wdpStart.Name := 'wdpStart';
    wdpStart.Left := 320;
    wdpStart.Top := 28;
    wdpStart.Width := 125;
    wdpStart.Height := 22;
    wdpStart.HeightStyle := ssAuto;
    wdpStart.AutoDropDown := True;
    wdpStart.BorderStyle := bsSingle;
    wdpStart.ChildOrder := 3;
    wdpStart.Color := clWhite;
    wdpStart.Date := 44908.760602962960000000;
    wdpStart.Font.Charset := DEFAULT_CHARSET;
    wdpStart.Font.Color := clWindowText;
    wdpStart.Font.Height := -12;
    wdpStart.Font.Name := 'Tahoma';
    wdpStart.Font.Style := [];
    wdpStart.ParentFont := False;
    wdpStart.Role := '';
    wdpStart.Text := '';
    wdpEnd.SetParentComponent(WebPanel1);
    wdpEnd.Name := 'wdpEnd';
    wdpEnd.Left := 478;
    wdpEnd.Top := 28;
    wdpEnd.Width := 125;
    wdpEnd.Height := 22;
    wdpEnd.HeightStyle := ssAuto;
    wdpEnd.AutoDropDown := True;
    wdpEnd.BorderStyle := bsSingle;
    wdpEnd.ChildOrder := 3;
    wdpEnd.Color := clWhite;
    wdpEnd.Date := 44908.760602962960000000;
    wdpEnd.Font.Charset := DEFAULT_CHARSET;
    wdpEnd.Font.Color := clWindowText;
    wdpEnd.Font.Height := -12;
    wdpEnd.Font.Name := 'Tahoma';
    wdpEnd.Font.Style := [];
    wdpEnd.ParentFont := False;
    wdpEnd.Role := '';
    wdpEnd.Text := '';
    btnSearch.SetParentComponent(WebPanel1);
    btnSearch.Name := 'btnSearch';
    btnSearch.Left := 648;
    btnSearch.Top := 28;
    btnSearch.Width := 121;
    btnSearch.Height := 36;
    btnSearch.Caption := 'Search';
    btnSearch.Color := clLightseagreen;
    btnSearch.Font.Charset := DEFAULT_CHARSET;
    btnSearch.Font.Color := clWindowText;
    btnSearch.Font.Height := -12;
    btnSearch.Font.Name := 'Tahoma';
    btnSearch.Font.Style := [];
    btnSearch.HeightPercent := 100.000000000000000000;
    btnSearch.MaterialGlyph := 'search';
    btnSearch.ParentFont := False;
    btnSearch.TabOrder := 4;
    btnSearch.WidthPercent := 100.000000000000000000;
    SetEvent(btnSearch, Self, 'OnClick', 'btnSearchClick');
    eRegNo.SetParentComponent(WebPanel1);
    eRegNo.Name := 'eRegNo';
    eRegNo.Left := 8;
    eRegNo.Top := 82;
    eRegNo.Width := 161;
    eRegNo.Height := 22;
    eRegNo.ChildOrder := 12;
    eRegNo.HeightPercent := 100.000000000000000000;
    eRegNo.ReadOnly := True;
    eRegNo.WidthPercent := 100.000000000000000000;
    SetEvent(eRegNo, Self, 'OnKeyDown', 'eRegNoKeyDown');
    btnRegNo.SetParentComponent(WebPanel1);
    btnRegNo.Name := 'btnRegNo';
    btnRegNo.Left := 169;
    btnRegNo.Top := 82;
    btnRegNo.Width := 24;
    btnRegNo.Height := 22;
    btnRegNo.Caption := '...';
    btnRegNo.Color := clNone;
    btnRegNo.Font.Charset := DEFAULT_CHARSET;
    btnRegNo.Font.Color := clWindowText;
    btnRegNo.Font.Height := -12;
    btnRegNo.Font.Name := 'Segoe UI';
    btnRegNo.Font.Style := [fsBold];
    btnRegNo.HeightPercent := 100.000000000000000000;
    btnRegNo.ParentFont := False;
    btnRegNo.TabOrder := 6;
    btnRegNo.WidthPercent := 100.000000000000000000;
    SetEvent(btnRegNo, Self, 'OnClick', 'btnRegNoClick');
    gInfo.SetParentComponent(WebScrollBox1);
    gInfo.Name := 'gInfo';
    gInfo.Left := 3;
    gInfo.Top := 122;
    gInfo.Width := 949;
    gInfo.Height := 300;
    gInfo.AdaptToStyle := True;
    gInfo.ParentDoubleBuffered := False;
    gInfo.DoubleBuffered := True;
    gInfo.TabOrder := 1;
    gInfo.DefaultRowHeight := 40.000000000000000000;
    gInfo.FixedColumns := 0;
    gInfo.ColumnCount := 10;
    gInfo.RowCount := 1;
    gInfo.Options.Bands.Enabled := True;
    gInfo.Options.Editing.CalcFormat := '%g';
    gInfo.Options.Grouping.CalcFormat := '%g';
    gInfo.Options.Grouping.GroupCountFormat := '(%d)';
    gInfo.Options.IO.XMLEncoding := 'ISO-8859-1';
    gInfo.Options.Mouse.ClickMargin := 0;
    gInfo.Options.Mouse.ColumnSizeMargin := 6;
    gInfo.Options.Mouse.RowSizeMargin := 6;
    gInfo.Options.Selection.ShowSelectionInFixedCells := True;
    gInfo.Columns.Clear;
    with gInfo.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 25.000000000000000000;
    end;
    with gInfo.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 75.000000000000000000;
    end;
    with gInfo.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 100.000000000000000000;
    end;
    with gInfo.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 100.000000000000000000;
    end;
    with gInfo.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 300.000000000000000000;
    end;
    with gInfo.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      ReadOnly := True;
      Width := 100.000000000000000000;
    end;
    with gInfo.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      ReadOnly := True;
      Width := 100.000000000000000000;
    end;
    with gInfo.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      ReadOnly := True;
      Width := 100.000000000000000000;
    end;
    with gInfo.Columns.Add do
    begin
      BorderWidth := 1;
      ColumnType := ctCheckBox;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaCenter;
      ID := '';
      ReadOnly := True;
      Width := 75.000000000000000000;
    end;
    with gInfo.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 150.000000000000000000;
    end;
    gInfo.DefaultFont.Charset := DEFAULT_CHARSET;
    gInfo.DefaultFont.Color := clBlack;
    gInfo.DefaultFont.Height := -11;
    gInfo.DefaultFont.Name := 'Segoe UI';
    gInfo.DefaultFont.Style := [];
    gInfo.Stroke.Color := 15987699;
    gInfo.TopRow := 1;
    gInfo.Appearance.FixedLayout.Fill.Kind := gfkGradient;
    gInfo.Appearance.FixedLayout.Fill.Color := 16382457;
    gInfo.Appearance.FixedLayout.Fill.ColorTo := 16382457;
    gInfo.Appearance.FixedLayout.Stroke.Color := 15987699;
    gInfo.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gInfo.Appearance.FixedLayout.Font.Color := clBlack;
    gInfo.Appearance.FixedLayout.Font.Height := -13;
    gInfo.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gInfo.Appearance.FixedLayout.Font.Style := [fsBold];
    gInfo.Appearance.NormalLayout.Fill.Color := 16578806;
    gInfo.Appearance.NormalLayout.Stroke.Color := 15987699;
    gInfo.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gInfo.Appearance.NormalLayout.Font.Color := clBlack;
    gInfo.Appearance.NormalLayout.Font.Height := -11;
    gInfo.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gInfo.Appearance.NormalLayout.Font.Style := [];
    gInfo.Appearance.GroupLayout.Fill.Kind := gfkGradient;
    gInfo.Appearance.GroupLayout.Fill.Color := 15385233;
    gInfo.Appearance.GroupLayout.Fill.ColorTo := 15385233;
    gInfo.Appearance.GroupLayout.Stroke.Color := 15987699;
    gInfo.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gInfo.Appearance.GroupLayout.Font.Color := clBlack;
    gInfo.Appearance.GroupLayout.Font.Height := -11;
    gInfo.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gInfo.Appearance.GroupLayout.Font.Style := [];
    gInfo.Appearance.SummaryLayout.Fill.Kind := gfkGradient;
    gInfo.Appearance.SummaryLayout.Fill.Color := 15385233;
    gInfo.Appearance.SummaryLayout.Fill.ColorTo := 15385233;
    gInfo.Appearance.SummaryLayout.Stroke.Color := 15987699;
    gInfo.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gInfo.Appearance.SummaryLayout.Font.Color := clBlack;
    gInfo.Appearance.SummaryLayout.Font.Height := -11;
    gInfo.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gInfo.Appearance.SummaryLayout.Font.Style := [];
    gInfo.Appearance.SelectedLayout.Fill.Kind := gfkGradient;
    gInfo.Appearance.SelectedLayout.Fill.Color := 15385233;
    gInfo.Appearance.SelectedLayout.Fill.ColorTo := 15385233;
    gInfo.Appearance.SelectedLayout.Stroke.Color := 15987699;
    gInfo.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gInfo.Appearance.SelectedLayout.Font.Color := clBlack;
    gInfo.Appearance.SelectedLayout.Font.Height := -11;
    gInfo.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gInfo.Appearance.SelectedLayout.Font.Style := [];
    gInfo.Appearance.FocusedLayout.Fill.Kind := gfkGradient;
    gInfo.Appearance.FocusedLayout.Fill.Color := 15385233;
    gInfo.Appearance.FocusedLayout.Fill.ColorTo := 15385233;
    gInfo.Appearance.FocusedLayout.Stroke.Color := 15987699;
    gInfo.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gInfo.Appearance.FocusedLayout.Font.Color := clBlack;
    gInfo.Appearance.FocusedLayout.Font.Height := -11;
    gInfo.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gInfo.Appearance.FocusedLayout.Font.Style := [];
    gInfo.Appearance.FixedSelectedLayout.Fill.Kind := gfkGradient;
    gInfo.Appearance.FixedSelectedLayout.Fill.Color := 15385233;
    gInfo.Appearance.FixedSelectedLayout.Fill.ColorTo := 15385233;
    gInfo.Appearance.FixedSelectedLayout.Stroke.Color := 15987699;
    gInfo.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gInfo.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gInfo.Appearance.FixedSelectedLayout.Font.Height := -11;
    gInfo.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gInfo.Appearance.FixedSelectedLayout.Font.Style := [];
    gInfo.Appearance.BandLayout.Fill.Color := 16711679;
    gInfo.Appearance.BandLayout.Stroke.Color := 15987699;
    gInfo.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gInfo.Appearance.BandLayout.Font.Color := 8026746;
    gInfo.Appearance.BandLayout.Font.Height := -11;
    gInfo.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gInfo.Appearance.BandLayout.Font.Style := [];
    gInfo.Appearance.ProgressLayout.Color := 15385233;
    gInfo.Appearance.ProgressLayout.Format := '%.0f%%';
    gInfo.LeftCol := 0;
    gInfo.ScrollMode := scmItemScrolling;
    gInfo.DesignTimeSampleData := True;
    SetEvent(gInfo, Self, 'OnGetCellLayout', 'gInfoGetCellLayout');
    wpBottom.SetParentComponent(WebScrollBox1);
    wpBottom.Name := 'wpBottom';
    wpBottom.Left := 0;
    wpBottom.Top := 421;
    wpBottom.Width := 949;
    wpBottom.Height := 79;
    wpBottom.ChildOrder := 2;
    btnNew.SetParentComponent(wpBottom);
    btnNew.Name := 'btnNew';
    btnNew.Left := 14;
    btnNew.Top := 36;
    btnNew.Width := 121;
    btnNew.Height := 36;
    btnNew.Caption := 'New';
    btnNew.Color := clBlue;
    btnNew.Font.Charset := DEFAULT_CHARSET;
    btnNew.Font.Color := clWhite;
    btnNew.Font.Height := -12;
    btnNew.Font.Name := 'Tahoma';
    btnNew.Font.Style := [fsBold];
    btnNew.HeightPercent := 100.000000000000000000;
    btnNew.ParentFont := False;
    btnNew.TabOrder := 0;
    btnNew.WidthPercent := 100.000000000000000000;
    SetEvent(btnNew, Self, 'OnClick', 'btnNewClick');
    btnEdit.SetParentComponent(wpBottom);
    btnEdit.Name := 'btnEdit';
    btnEdit.Left := 141;
    btnEdit.Top := 36;
    btnEdit.Width := 121;
    btnEdit.Height := 36;
    btnEdit.Caption := 'Edit';
    btnEdit.Color := clGreenyellow;
    btnEdit.Font.Charset := DEFAULT_CHARSET;
    btnEdit.Font.Color := clBlack;
    btnEdit.Font.Height := -12;
    btnEdit.Font.Name := 'Tahoma';
    btnEdit.Font.Style := [fsBold];
    btnEdit.HeightPercent := 100.000000000000000000;
    btnEdit.ParentFont := False;
    btnEdit.TabOrder := 1;
    btnEdit.Visible := False;
    btnEdit.WidthPercent := 100.000000000000000000;
    SetEvent(btnEdit, Self, 'OnClick', 'btnEditClick');
    btnCancel.SetParentComponent(wpBottom);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 268;
    btnCancel.Top := 36;
    btnCancel.Width := 121;
    btnCancel.Height := 36;
    btnCancel.Caption := 'Cancel';
    btnCancel.Color := clCrimson;
    btnCancel.Font.Charset := DEFAULT_CHARSET;
    btnCancel.Font.Color := clWhite;
    btnCancel.Font.Height := -12;
    btnCancel.Font.Name := 'Tahoma';
    btnCancel.Font.Style := [fsBold];
    btnCancel.HeightPercent := 100.000000000000000000;
    btnCancel.ParentFont := False;
    btnCancel.TabOrder := 2;
    btnCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
    btnClose.SetParentComponent(wpBottom);
    btnClose.Name := 'btnClose';
    btnClose.Left := 645;
    btnClose.Top := 36;
    btnClose.Width := 121;
    btnClose.Height := 36;
    btnClose.Caption := 'Close';
    btnClose.Color := clLightseagreen;
    btnClose.Font.Charset := DEFAULT_CHARSET;
    btnClose.Font.Color := clWindowText;
    btnClose.Font.Height := -12;
    btnClose.Font.Name := 'Tahoma';
    btnClose.Font.Style := [];
    btnClose.HeightPercent := 100.000000000000000000;
    btnClose.MaterialGlyph := 'close';
    btnClose.ParentFont := False;
    btnClose.TabOrder := 3;
    btnClose.WidthPercent := 100.000000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    ePages.SetParentComponent(wpBottom);
    ePages.Name := 'ePages';
    ePages.Left := 60;
    ePages.Top := 5;
    ePages.Width := 52;
    ePages.Height := 22;
    ePages.Alignment := taCenter;
    ePages.ChildOrder := 4;
    ePages.HeightPercent := 100.000000000000000000;
    ePages.ReadOnly := True;
    ePages.Text := '1 of 1';
    ePages.WidthPercent := 100.000000000000000000;
    btnFirst.SetParentComponent(wpBottom);
    btnFirst.Name := 'btnFirst';
    btnFirst.Left := 13;
    btnFirst.Top := 5;
    btnFirst.Width := 24;
    btnFirst.Height := 22;
    btnFirst.Caption := '<<';
    btnFirst.Color := clNone;
    btnFirst.HeightPercent := 100.000000000000000000;
    btnFirst.TabOrder := 5;
    btnFirst.WidthPercent := 100.000000000000000000;
    SetEvent(btnFirst, Self, 'OnClick', 'btnFirstClick');
    btnNext.SetParentComponent(wpBottom);
    btnNext.Name := 'btnNext';
    btnNext.Left := 112;
    btnNext.Top := 5;
    btnNext.Width := 24;
    btnNext.Height := 22;
    btnNext.Caption := '>';
    btnNext.Color := clNone;
    btnNext.HeightPercent := 100.000000000000000000;
    btnNext.TabOrder := 6;
    btnNext.WidthPercent := 100.000000000000000000;
    SetEvent(btnNext, Self, 'OnClick', 'btnNextClick');
    btnPrior.SetParentComponent(wpBottom);
    btnPrior.Name := 'btnPrior';
    btnPrior.Left := 36;
    btnPrior.Top := 5;
    btnPrior.Width := 24;
    btnPrior.Height := 22;
    btnPrior.Caption := '<';
    btnPrior.Color := clNone;
    btnPrior.HeightPercent := 100.000000000000000000;
    btnPrior.TabOrder := 7;
    btnPrior.WidthPercent := 100.000000000000000000;
    SetEvent(btnPrior, Self, 'OnClick', 'btnPriorClick');
    btnLast.SetParentComponent(wpBottom);
    btnLast.Name := 'btnLast';
    btnLast.Left := 135;
    btnLast.Top := 5;
    btnLast.Width := 24;
    btnLast.Height := 22;
    btnLast.Caption := '>>';
    btnLast.Color := clNone;
    btnLast.HeightPercent := 100.000000000000000000;
    btnLast.TabOrder := 8;
    btnLast.WidthPercent := 100.000000000000000000;
    SetEvent(btnLast, Self, 'OnClick', 'btnLastClick');
    webconnect.SetParentComponent(Self);
    webconnect.Name := 'webconnect';
    webconnect.Connection := dmData.dbConnect;
    webconnect.Left := 160;
    webconnect.Top := 305;
    qInfo.SetParentComponent(Self);
    qInfo.Name := 'qInfo';
    qInfo.AfterOpen := qInfoAfterOpen;
    qInfo.Connection := dmData.dbConnect;
    qInfo.Left := 296;
    qInfo.Top := 281;
    qInfoOrderNo.SetParentComponent(qInfo);
    qInfoOrderNo.Name := 'qInfoOrderNo';
    qInfoOrderNo.FieldName := 'OrderNo';
    qInfoOrderDate.SetParentComponent(qInfo);
    qInfoOrderDate.Name := 'qInfoOrderDate';
    qInfoOrderDate.FieldName := 'OrderDate';
    qInfoRegNo.SetParentComponent(qInfo);
    qInfoRegNo.Name := 'qInfoRegNo';
    qInfoRegNo.FieldName := 'RegNo';
    qInfoDepotCode.SetParentComponent(qInfo);
    qInfoDepotCode.Name := 'qInfoDepotCode';
    qInfoDepotCode.FieldName := 'DepotCode';
    qInfoDepotName.SetParentComponent(qInfo);
    qInfoDepotName.Name := 'qInfoDepotName';
    qInfoDepotName.FieldName := 'DepotName';
    qInfoSubCode.SetParentComponent(qInfo);
    qInfoSubCode.Name := 'qInfoSubCode';
    qInfoSubCode.FieldName := 'SubCode';
    qInfoSubName.SetParentComponent(qInfo);
    qInfoSubName.Name := 'qInfoSubName';
    qInfoSubName.FieldName := 'SubName';
    qInfoFleetNo.SetParentComponent(qInfo);
    qInfoFleetNo.Name := 'qInfoFleetNo';
    qInfoFleetNo.FieldName := 'FleetNo';
    qInfoOrderLiters.SetParentComponent(qInfo);
    qInfoOrderLiters.Name := 'qInfoOrderLiters';
    qInfoOrderLiters.FieldName := 'OrderLiters';
    qInfoInvoicedLiters.SetParentComponent(qInfo);
    qInfoInvoicedLiters.Name := 'qInfoInvoicedLiters';
    qInfoInvoicedLiters.FieldName := 'InvoicedLiters';
    qInfoCanceled.SetParentComponent(qInfo);
    qInfoCanceled.Name := 'qInfoCanceled';
    qInfoCanceled.FieldName := 'Canceled';
    qInfoCInvoiced.SetParentComponent(qInfo);
    qInfoCInvoiced.Name := 'qInfoCInvoiced';
    qInfoCInvoiced.FieldName := 'CInvoiced';
    qInfoSInvoiced.SetParentComponent(qInfo);
    qInfoSInvoiced.Name := 'qInfoSInvoiced';
    qInfoSInvoiced.FieldName := 'SInvoiced';
    qInfoSupplierCode.SetParentComponent(qInfo);
    qInfoSupplierCode.Name := 'qInfoSupplierCode';
    qInfoSupplierCode.FieldName := 'SupplierCode';
    qInfoSupplierName.SetParentComponent(qInfo);
    qInfoSupplierName.Name := 'qInfoSupplierName';
    qInfoSupplierName.FieldName := 'SupplierName';
    qInfoSOrderNo.SetParentComponent(qInfo);
    qInfoSOrderNo.Name := 'qInfoSOrderNo';
    qInfoSOrderNo.FieldName := 'SOrderNo';
    qInfoSInvoiceNo.SetParentComponent(qInfo);
    qInfoSInvoiceNo.Name := 'qInfoSInvoiceNo';
    qInfoSInvoiceNo.FieldName := 'SInvoiceNo';
    qInfoOrderPrice.SetParentComponent(qInfo);
    qInfoOrderPrice.Name := 'qInfoOrderPrice';
    qInfoOrderPrice.FieldName := 'OrderPrice';
    qInfoOrderAmount.SetParentComponent(qInfo);
    qInfoOrderAmount.Name := 'qInfoOrderAmount';
    qInfoOrderAmount.FieldName := 'OrderAmount';
    qInfoFillType.SetParentComponent(qInfo);
    qInfoFillType.Name := 'qInfoFillType';
    qInfoFillType.FieldName := 'FillType';
    qInfoInProgress.SetParentComponent(qInfo);
    qInfoInProgress.Name := 'qInfoInProgress';
    qInfoInProgress.FieldName := 'InProgress';
    dsInfo.SetParentComponent(Self);
    dsInfo.Name := 'dsInfo';
    dsInfo.AutoEdit := False;
    dsInfo.DataSet := qInfo;
    dsInfo.Left := 264;
    dsInfo.Top := 193;
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Interval := 60000;
    SetEvent(WebTimer1, Self, 'OnTimer', 'WebTimer1Timer');
    WebTimer1.Left := 680;
    WebTimer1.Top := 49;
    qStatus.SetParentComponent(Self);
    qStatus.Name := 'qStatus';
    qStatus.Connection := dmData.dbConnect;
    qStatus.Left := 304;
    qStatus.Top := 256;
    qStatusOrderNo.SetParentComponent(qStatus);
    qStatusOrderNo.Name := 'qStatusOrderNo';
    qStatusOrderNo.FieldName := 'OrderNo';
    qStatusValid.SetParentComponent(qStatus);
    qStatusValid.Name := 'qStatusValid';
    qStatusValid.FieldName := 'Valid';
    qStatusSystemMessage.SetParentComponent(qStatus);
    qStatusSystemMessage.Name := 'qStatusSystemMessage';
    qStatusSystemMessage.FieldName := 'SystemMessage';
  finally
    MessageDlg.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebScrollBox1.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    eSubsCompany.AfterLoadDFMValues;
    btnSearchSubs.AfterLoadDFMValues;
    wdpStart.AfterLoadDFMValues;
    wdpEnd.AfterLoadDFMValues;
    btnSearch.AfterLoadDFMValues;
    eRegNo.AfterLoadDFMValues;
    btnRegNo.AfterLoadDFMValues;
    gInfo.AfterLoadDFMValues;
    wpBottom.AfterLoadDFMValues;
    btnNew.AfterLoadDFMValues;
    btnEdit.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    ePages.AfterLoadDFMValues;
    btnFirst.AfterLoadDFMValues;
    btnNext.AfterLoadDFMValues;
    btnPrior.AfterLoadDFMValues;
    btnLast.AfterLoadDFMValues;
    webconnect.AfterLoadDFMValues;
    qInfo.AfterLoadDFMValues;
    qInfoOrderNo.AfterLoadDFMValues;
    qInfoOrderDate.AfterLoadDFMValues;
    qInfoRegNo.AfterLoadDFMValues;
    qInfoDepotCode.AfterLoadDFMValues;
    qInfoDepotName.AfterLoadDFMValues;
    qInfoSubCode.AfterLoadDFMValues;
    qInfoSubName.AfterLoadDFMValues;
    qInfoFleetNo.AfterLoadDFMValues;
    qInfoOrderLiters.AfterLoadDFMValues;
    qInfoInvoicedLiters.AfterLoadDFMValues;
    qInfoCanceled.AfterLoadDFMValues;
    qInfoCInvoiced.AfterLoadDFMValues;
    qInfoSInvoiced.AfterLoadDFMValues;
    qInfoSupplierCode.AfterLoadDFMValues;
    qInfoSupplierName.AfterLoadDFMValues;
    qInfoSOrderNo.AfterLoadDFMValues;
    qInfoSInvoiceNo.AfterLoadDFMValues;
    qInfoOrderPrice.AfterLoadDFMValues;
    qInfoOrderAmount.AfterLoadDFMValues;
    qInfoFillType.AfterLoadDFMValues;
    qInfoInProgress.AfterLoadDFMValues;
    dsInfo.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
    qStatus.AfterLoadDFMValues;
    qStatusOrderNo.AfterLoadDFMValues;
    qStatusValid.AfterLoadDFMValues;
    qStatusSystemMessage.AfterLoadDFMValues;
  end;
end;

end.